import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import { combineReducers } from "redux";
import { encryptedStorage } from "./utils/storageUtils";
import { userLoginReducer, userSignUpReducer } from "./reducers/userReducers";
import {
  chatHistoryReducer,
  chatTitlesReducer,
  checkServerReducer,
  newChatReducer,
} from "./reducers/chatReducers";
import {
  deletePetitionReducer,
  editPetitionTitleReducer,
  newPetitionReducer,
  petitionHistoryReducer,
  petitionTitlesReducer,
  selectedPetitionReducer,
} from "./reducers/petitionReducers";
import {
  caseDetailReducer,
  caseDetailsFromCosmosReducer,
  caseFiltersReducer,
  searchFilterPaginationReducer,
  searchFilterValuesReducer,
  searchResultsCountReducer,
  searchResultsReducer,
  searchSelectedFiltersReducer,
} from "./reducers/searchReducers";
import statuteSearchReducer, {
  statutePaginationReducer,
  statutePdfPreviewReducer,
  statuteSearchFilterReducer,
  statuteSectionsReducer,
} from "./reducers/statuteSearchReducer";
import { statuteTitleReducer } from "./reducers/statuteSearchReducer";
import {
  applicationTitlesReducer,
  deleteApplicationReducer,
  newapplicationReducer,
  selectedApplicationReducer,
} from "./reducers/applicationReducers";
import {
  contractTitlesReducer,
  deleteContractReducer,
  newcontractReducer,
  selectedContractReducer,
} from "./reducers/contractReducers";
import { persistStore, persistReducer } from "redux-persist";
import creditReducer from "./reducers/creditReducers";
import {
  bookmarkCasesReducer,
  bookmarkCmsDocsReducer,
  bookmarkGroupsReducer,
  bookmarkStatutesReducer,
} from "./store/Bookmarks/bookmarksReducers";
import {
  listingFiltersReducer,
  listingSearchTermsReducer,
  listingsReducer,
} from "./store/CaseSearch/reducers";
import { USER_INFO_KEY } from "./utils/HelperFunction/Constants";
import { getDecryptedItem } from "./utils/storageUtils";

const persistConfig = {
  key: "root",
  storage: encryptedStorage,
  whitelist: ["chatTitles", "credit", "userLogin"],
};

const reducer = combineReducers({
  userLogin: userLoginReducer,
  userSignup: userSignUpReducer,
  chatTitles: chatTitlesReducer,
  petitionTitles: petitionTitlesReducer,
  newChat: newChatReducer,
  newPetitionRequest: newPetitionReducer,
  chatHistory: chatHistoryReducer,
  petitionHistory: petitionHistoryReducer,
  editPetitionTitle: editPetitionTitleReducer,
  selectedPetition: selectedPetitionReducer,
  deletePetition: deletePetitionReducer,
  serverStatus: checkServerReducer,
  searchResultsCount: searchResultsCountReducer,
  searchResults: searchResultsReducer,
  searchFilters: searchFilterValuesReducer,
  searchFiltersPagination: searchFilterPaginationReducer,
  selectedFilters: searchSelectedFiltersReducer,
  caseDetail: caseDetailReducer,
  caseDetailsFromCosmos: caseDetailsFromCosmosReducer,
  caseFilters: caseFiltersReducer,
  statutePagination: statutePaginationReducer,
  statuteSearch: statuteSearchReducer,
  isStatuteFilterApplied: statuteSearchFilterReducer,
  statuteSections: statuteSectionsReducer,
  statuteTitle: statuteTitleReducer,
  statutePdfPreviewUrl: statutePdfPreviewReducer,
  newApplicationRequest: newapplicationReducer,
  selectedApplication: selectedApplicationReducer,
  applicationTitles: applicationTitlesReducer,
  deleteApplication: deleteApplicationReducer,
  newContractRequest: newcontractReducer,
  selectedContract: selectedContractReducer,
  contractTitles: contractTitlesReducer,
  deleteContract: deleteContractReducer,
  credit: creditReducer,
  bookmarkGroups: bookmarkGroupsReducer,
  bookmarkCases: bookmarkCasesReducer,
  bookmarkStatutes: bookmarkStatutesReducer,
  bookmarkCmsDocs: bookmarkCmsDocsReducer,
  listingFilters: listingFiltersReducer,
  listingSearchTerms: listingSearchTermsReducer,
  listings: listingsReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const middleware = [thunk];

const userInfoFromStorage = getDecryptedItem(USER_INFO_KEY);

const preloadedState = {
  userLogin: { userInfo: userInfoFromStorage },
};

const store = configureStore({
  reducer: persistedReducer,
  middleware,
  preloadedState,
});

const persistor = persistStore(store);

export { store, persistor };
